import { useCallback, useState } from 'react';

export function getNextSortState(sortBy, sortDir, field) {
  if (sortBy === field) {
    return {
      sortBy: field,
      sortDir: sortDir === 'asc' ? 'desc' : 'asc',
    };
  }

  return {
    sortBy: field,
    sortDir: 'asc',
  };
}

export function getSortIcon(sortBy, sortDir, field) {
  if (sortBy !== field) return '';
  return sortDir === 'asc' ? ' ↑' : ' ↓';
}

export default function useTableSort({
  initialSortBy = null,
  initialSortDir = 'asc',
  onSort,
} = {}) {
  const [sortBy, setSortBy] = useState(initialSortBy);
  const [sortDir, setSortDir] = useState(initialSortDir);

  const handleSort = useCallback((field) => {
    const next = getNextSortState(sortBy, sortDir, field);
    setSortBy(next.sortBy);
    setSortDir(next.sortDir);
    onSort?.(next);
  }, [sortBy, sortDir, onSort]);

  const sortIcon = useCallback(
    (field) => getSortIcon(sortBy, sortDir, field),
    [sortBy, sortDir],
  );

  const getSortableHeaderProps = useCallback((field) => ({
    onClick: () => handleSort(field),
    style: {
      cursor: 'pointer',
      userSelect: 'none',
    },
  }), [handleSort]);

  return {
    sortBy,
    sortDir,
    handleSort,
    sortIcon,
    getSortableHeaderProps,
  };
}
